<div class="position-relative h-100 d-flex justify-content-between flex-column">
  <mat-tab-group class="login-section-wrapper h-100" [(selectedIndex)]="selectedIndex">
    <mat-tab disabled>
      <ng-template matTabContent>
        <div class="login-section">
          <div class="mb-5">
            <div class="fw-bolder text-center login-title">Log in to the Truein dashboard</div>
            <!-- <small class="text-secondary">
              Login to access Truein web dashboard
            </small> -->
          </div>
          <div class="login-section-input mt-3">
            <form [formGroup]="loginForm" class="my-3">
              <mat-form-field appearance="outline">
                <mat-label>Your Mobile/Email</mat-label>
                <input [disabled]="is_logging || show_password_field" formControlName="mobile_email" type="text" name="email" matInput placeholder="Mobile/Email" autocomplete="tel email" aria-label="Email address or mobile number">
                <mat-error>Mobile Number or Email Address is required</mat-error>
              </mat-form-field>

              <div *ngIf="show_password_field" [@expandOnEnter] [@collapseOnLeave]>
                <mat-form-field appearance="outline">
                  <mat-label>Password</mat-label>
                  <input [type]="is_pass_type_password ? 'text' : 'password'" name="pass" matInput [disabled]="is_logging" formControlName="password" placeholder="********" aria-label="Password">
                  <mat-icon class="password-visbility-icon" matSuffix style="cursor: pointer" (click)="is_pass_type_password = !is_pass_type_password;">{{
                    is_pass_type_password ?
                    'visibility_off' :
                    'visibility'}}</mat-icon>
                  <mat-error>
                    <ng-container *ngIf="loginForm.get('password')?.hasError('required')">
                      Password is required
                    </ng-container>
                    <ng-container *ngIf="loginForm.get('password')?.hasError('maxlength')">
                      Password should be less than 20 characters
                    </ng-container>
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="d-flex flex-column">
                <div class="d-flex justify-content-center align-items-center flex-column forgot-pass position-relative" [style.margin-top]="(error_msg != '' || verify_otp_error_msg != '') ? '0' : '1rem'">
                  <small *ngIf="error_msg != '' || verify_otp_error_msg != ''" class="form-error-msg-text text-center" [innerHTML]="verify_otp_error_msg != '' ? verify_otp_error_msg : error_msg"></small>
                  <button [disabled]="google_signin_loading || microsoft_signin_loading || sso_signin_loading" *ngIf="!is_logging" mat-flat-button color="primary" class="login-btn" [ngClass]="(error_msg != '' || verify_otp_error_msg != '') ? 'mt-3' : ''" (click)="loginForm.invalid || (show_password_field && !loginForm.get('password').value) ? validateLoginFormFields() : getLoginDetails('self_user')">
                    <ng-container *ngIf="is_initial_logging">
                      Next
                    </ng-container>
                    <ng-container *ngIf="!is_initial_logging">
                      <mat-icon class="login-lock-icon">lock</mat-icon> Log in
                    </ng-container>
                  </button>
                  <mat-icon *ngIf="is_logging"><mat-spinner diameter="24"></mat-spinner></mat-icon>
                </div>
              </div>
            </form>

            <div class="mt-4 d-flex flex-column justify-content-center align-items-center position-relative sso-button-wrapper">
              <div class="d-flex justify-content-center align-items-center position-relative">
                <span class="position-relative">
                  <button class="gsi-material-button" (click)="signInWithGoogle()" [disabled]="microsoft_signin_loading || google_signin_loading || sso_signin_loading || is_logging">
                    <div class="gsi-material-button-state"></div>
                    <div class="gsi-material-button-content-wrapper">
                      <div class="gsi-material-button-icon">
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" xmlns:xlink="http://www.w3.org/1999/xlink" style="display: block;">
                          <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
                          <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
                          <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
                          <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
                          <path fill="none" d="M0 0h48v48H0z"></path>
                        </svg>
                      </div>
                      <span style="display: none;">Sign in with Google</span>
                    </div>
                  </button>
                  <mat-spinner diameter="16" class="g-user-loader position-absolute" *ngIf="google_signin_loading"></mat-spinner>
                </span>
                <span class="position-relative">
                  <button class="gsi-material-button ms-2" (click)="signInWithMicrosoft()" [disabled]="microsoft_signin_loading || google_signin_loading || sso_signin_loading || is_logging">
                    <div class="gsi-material-button-state"></div>
                    <div class="gsi-material-button-content-wrapper">
                      <div class="gsi-material-button-icon mx-0">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 23" style="display: block;">
                          <path fill="#f3f3f3" d="M0 0h23v23H0z"/>
                          <path fill="#f35325" d="M1 1h10v10H1z"/>
                          <path fill="#81bc06" d="M12 1h10v10H12z"/>
                          <path fill="#05a6f0" d="M1 12h10v10H1z"/>
                          <path fill="#ffba08" d="M12 12h10v10H12z"/>
                        </svg>
                      </div>
                      <span class="ms-signin-text">Sign in</span>
                    </div>
                  </button>
                  <mat-spinner diameter="16" class="m-user-loader position-absolute" *ngIf="microsoft_signin_loading"></mat-spinner>
                </span>
              </div>
              <span class="position-relative w-100 d-flex justify-content-center" *ngIf="login_response?.data?.saml_sso_url" [@expandOnEnter] [@collapseOnLeave]>
                <button class="gsi-material-button sso-button w-100" (click)="openSSOUrl()" [disabled]="microsoft_signin_loading || google_signin_loading || is_logging || sso_signin_loading">
                  <span class="ms-signin-text">Sign in with SSO</span>
                </button>
                <mat-spinner diameter="16" class="m-user-loader position-absolute" *ngIf="sso_signin_loading"></mat-spinner>
              </span>
            </div>

            <div class="mt-5 d-flex justify-content-center align-items-center forgot-pass">
              <a class="tab-change-link" (click)="getResetPassTab()">Forgot Password ?</a>
            </div>
          </div>
        </div>
      </ng-template>
    </mat-tab>
    <mat-tab disabled>
      <ng-container>
        <div class="update-pass-wrapper">
          <div class="mb-4">
            <div style="font-size:16px;" class="fw-bolder text-center">Update Password</div>
            <!-- <small class="text-secondary">
                Signup to create an account with us
            </small> -->
          </div>
          <p [innerHtml]="verify_otp_success_msg" *ngIf="verify_otp_success_msg != '' && selectedIndex == '1'"></p>
          <form [formGroup]="updatePasswordForm" class="update-section-input relative" [style.margin-top]="verify_otp_success_msg != '' ? '1rem' : '0'">
            <div class="mb-3 d-flex flex-column justify-content-center">
              <app-otp-verification
                [control]="updatePasswordForm.get('otp_ctrl')"
                [showVerifyButton]="false"
                [resendCooldownSeconds]="60"
                [isResending]="is_passReset"
                [resendStartTick]="force_update_resendStartTick"
                (resend)="forgotPassword()">
              </app-otp-verification>
            </div>
            <mat-divider class="field-divider mb-1"></mat-divider>
            <div class="pass-input-fields">
              <mat-form-field appearance="outline">
                <input formControlName="new_password" [disabled]="is_passUpdating" autocomplete="new-password" [type]="is_new_pass_type_password ? 'text' : 'password'" matInput placeholder="New Password" aria-label="New Password">
                <mat-icon class="password-visbility-icon" matSuffix style="cursor: pointer" (click)="is_new_pass_type_password = !is_new_pass_type_password;">{{
                  is_new_pass_type_password ?
                  'visibility_off' :
                  'visibility'}}</mat-icon>
                <mat-error *ngIf="updatePasswordForm.controls['new_password'].invalid && (updatePasswordForm.controls['new_password'].dirty || updatePasswordForm.controls['new_password'].touched)">
                  <div *ngIf="updatePasswordForm.controls['new_password'].errors?.required">Enter new Password</div>
                  <div *ngIf="!updatePasswordForm.controls['new_password'].errors?.required && !updatePasswordForm.controls['new_password'].errors?.maxlength">{{getFieldErrorMsg('new_password')}}</div>
                  <div *ngIf="updatePasswordForm.controls['new_password'].errors?.maxlength">Password should be less than 20 characters</div>
                </mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <input formControlName="confirm_password" [disabled]="is_passUpdating" autocomplete="new-password" [type]="is_old_pass_type_password ? 'text' : 'password'" matInput placeholder="Confirm Password" aria-label="Confirm Password">
                <mat-icon class="password-visbility-icon" matSuffix style="cursor: pointer" (click)="is_old_pass_type_password = !is_old_pass_type_password;">{{
                  is_old_pass_type_password ?
                  'visibility_off' :
                  'visibility'}}</mat-icon>
                <mat-error *ngIf="updatePasswordForm.controls['confirm_password'].invalid && (updatePasswordForm.controls['confirm_password'].dirty || updatePasswordForm.controls['confirm_password'].touched)">
                  <div *ngIf="updatePasswordForm.controls['confirm_password'].errors?.required">Confirm new Password</div>
                  <div *ngIf="updatePasswordForm.controls['confirm_password'].errors?.mismatch">Passwords do not match</div>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="pass-status d-flex flex-column">
              <div class="d-flex align-items-center">
                <mat-icon *ngIf="updatePasswordForm.get('new_password').value.length >= 8 && updatePasswordForm.get('new_password').value.length <= 20; else unchecked" style="color:green">check_circle</mat-icon>
                <span>Password must be between 8 and 20 characters.</span>
              </div>
              <div class="d-flex align-items-center">
                <mat-icon *ngIf="newPasswordHasUppercase(); else unchecked" style="color:green">check_circle</mat-icon>
                <span>Password must contain at least one uppercase letter.</span>
              </div>
              <div class="d-flex align-items-center">
                <mat-icon *ngIf="newPasswordHasNumber(); else unchecked" style="color:green">check_circle</mat-icon>
                <span>Password must contain at least one number.</span>
              </div>
              <ng-container *ngIf="policyType === 'strong'">
                <div class="d-flex align-items-center">
                  <mat-icon *ngIf="newPasswordHasLowercase(); else unchecked" style="color:green">check_circle</mat-icon>
                  <span>Password must contain at least one lowercase letter.</span>
                </div>
                <div class="d-flex align-items-center">
                  <mat-icon *ngIf="newPasswordHasSpecialChar(); else unchecked" style="color:green">check_circle</mat-icon>
                  <span>Password must contain at least one special character.</span>
                </div>
              </ng-container>
            </div>
            <div class="mt-4 d-flex justify-content-center flex-column align-items-center">
              <small *ngIf="update_pass_error_msg != ''" class="form-error-msg-text" [innerHTML]="update_pass_error_msg"></small>
              <button mat-flat-button color="primary" class="update-pass-btn" [style.margin-top]="update_pass_error_msg != '' ? '1rem' : '0'"  *ngIf="!is_passUpdating" (click)="verifyOtp()">
                Update Password
              </button>
              <mat-icon *ngIf="is_passUpdating"><mat-spinner diameter="24"></mat-spinner></mat-icon>
            </div>
          </form>
        </div>
      </ng-container>
    </mat-tab>
    <mat-tab disabled>
      <div class="mt-5 pt-5 w-100 d-flex justify-content-center">
        <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
         <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="#1531A9" />
         <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
        </svg>
      </div>
      <div class="py-4 pass-success-container d-flex justify-content-center text-center align-items-center">
        Password Updated Successfully!
      </div>
      <!-- <mat-divider class="position-relative"></mat-divider> -->
      <div class="d-flex justify-content-center align-items-center forgot-pass">
        <!-- <a class="tab-change-link" (click)="nextTab()">{{(selectedIndex == 2 && login_response?.data?.client_details?.length > 1) ? 'Next' : 'Go To Truein Dashboard'}}</a> -->
        <button type="button" class="my-0 next-btn" mat-flat-button (click)="nextTab()">
          {{ (selectedIndex == 2 && login_response?.data?.client_details?.length > 1) ? 'Next' : 'Go To Truein Dashboard' }}
        </button>
      </div>
    </mat-tab>
    <mat-tab disabled>
      <ng-template matTabContent>
        <app-verify-account [login_response]="login_response" [from_page]="'login'" (userSitesTab)="getSelectOrgTab()" (loginDashboard)="openDashboardWindow()"></app-verify-account>
      </ng-template>
    </mat-tab>
    <mat-tab disabled>
      <!-- <ng-container *ngIf="login_response?.data?.client_details?.length > 0"> -->
        <div class="org-selection d-flex flex-column" id="org_selection">
          <div class="mb-5 text-center">
            <div style="font-size:16px;" class="fw-bolder">Select Organization</div>
            <!-- <small class="text-secondary">
              Select your organization
            </small> -->
          </div>
          <div class="org-selection-list-container d-flex flex-column">
            <ng-container *ngFor="let client of client_details; let last = last">
              <div class="client-title d-flex flex-column-reverse" (click)="client?.staff_is_active ? client?.staff_is_active == '1' ? updateOrgClient(client?.client_id) : '' : updateOrgClient(client?.client_id)" [attr.client_active]="client?.staff_is_active ? client?.staff_is_active : '1'" [style.cursor]="client?.staff_is_active ? client?.staff_is_active == '1' ? 'pointer' : 'default' : 'pointer'" [matTooltip]="client?.staff_is_active ? client?.staff_is_active == '1' ? '' : client?.message : ''">
                <div class="d-flex justify-content-between">
                  <div class="title" [style.color]="client?.staff_is_active ? client?.staff_is_active == '1' ? '#535353' : '#9a9a9a' : '#535353'">{{client?.client_name}}</div>
                  <div class="icon" [style.color]="client?.staff_is_active ? client?.staff_is_active == '1' ? '#535353' : '#9a9a9a' : '#535353'"> &gt; </div>
                </div>
                <mat-divider *ngIf="!last" class="org-divider"></mat-divider>
              </div>
            </ng-container>
          </div>
        </div>
      <!-- </ng-container> -->
    </mat-tab>
    <mat-tab disabled>
      <ng-template matTabContent>
        <div class="mfa-section-wrapper">
          <div class="mb-2">
            <div style="font-size:16px;" class="fw-bolder text-center">Verify OTP</div>
            <div *ngIf="mfa_subtitle" class="mfa-masked-subtitle text-center mt-5">
              {{ mfa_subtitle }}
            </div>
          </div>
          <app-otp-verification
            [showVerifyButton]="true"
            [resendCooldownSeconds]="60"
            [maxAttempts]="3"
            [isVerifying]="is_mfaVerifying"
            [isResending]="is_mfaResending"
            [errorMsg]="mfa_error_msg"
            [invalidOtpTick]="mfa_invalidOtpTick"
            [resendStartTick]="mfa_resendStartTick"
            [resetTick]="mfa_resetTick"
            [disabled]="mfa_max_attempts_reached"
            (verify)="onMfaVerify($event)"
            (resend)="onMfaResend()"
            (maxAttemptsExceeded)="onMfaMaxAttempts()">
          </app-otp-verification>
          <div *ngIf="mfa_max_attempts_reached" class="mfa-redirect-banner text-center mt-2">
            <div>Redirecting to login in {{ mfa_redirect_countdown }}s...</div>
            <a class="mfa-redirect-now-link" (click)="goToLoginNow()">Go to login now</a>
          </div>
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>

  <ng-container *ngIf="selectedIndex != 0 && selectedIndex != 5 && !is_from_verify_account">
    <div>
      <mat-divider class="logout-text-divider"></mat-divider>
      <div class="text-center">
        <a class="tab-change-link" (click)="onLogOut()">Log Out</a>
      </div>
    </div>
  </ng-container>
</div>


<ng-template #unchecked>
  <mat-icon style="color:crimson" matTooltipPosition="right">remove_circle</mat-icon>
</ng-template>
